import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://fonalxasxbllhvchlvij.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZvbmFseGFzeGJsbGh2Y2hsdmlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1MTc5MDAsImV4cCI6MjA4MTA5MzkwMH0.FwiNSzdo6zwq7Zm1rh9BHT05BSc6YZeHgJ72dnVUFMY";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
